import { render, staticRenderFns } from "./NotificationItem.vue?vue&type=template&id=94dcb640&scoped=true&"
import script from "./NotificationItem.vue?vue&type=script&lang=js&"
export * from "./NotificationItem.vue?vue&type=script&lang=js&"
import style0 from "./NotificationItem.vue?vue&type=style&index=0&id=94dcb640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94dcb640",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94dcb640')) {
      api.createRecord('94dcb640', component.options)
    } else {
      api.reload('94dcb640', component.options)
    }
    module.hot.accept("./NotificationItem.vue?vue&type=template&id=94dcb640&scoped=true&", function () {
      api.rerender('94dcb640', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/General/Header/Notifications/NotificationItem.vue"
export default component.exports